/**
 * Toggles the active state of the menu button when clicked.
 *
 * @param {Event} event - The click event object.
 */
function toggle(event) {
	// Find the nearest ancestor with the 'js-menu-btn' class.
	const btn = event.target.closest('.js-toggle');

	// Check if the button is found.
	if (!btn) return;

	// Determine the current status and toggle the active class accordingly.
	let status = !btn.classList.contains('toggle--active');
	btn.classList.toggle('toggle--active', status);
}

/**
 * Adds a click event listener to the document for the menu button.
 */
function toggleListeners() {
	document.addEventListener('click', toggle);
}

// Initialise the event listeners when the DOM is fully loaded.
document.addEventListener('DOMContentLoaded', toggleListeners);
